module.exports = __webpack_public_path__ + "img/live-webinar.075a3c7e.png";